import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Calendar } from "react-date-range";
import { useForm } from "react-hook-form";
import { SlCalender } from "react-icons/sl";
import CountryModal from "../../../common/country_modal/countryModal";
import Header from "../../../common/Header";
import style from "./editProfile.module.css";

import moment from "moment/moment";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { AiOutlineMail } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dropdown from "../../../assets/Registration/bi_chevron-expand.svg";
import checkAnimation from "../../../assets/Registration/check_animation.gif";
import LoadingSpinner from "../../../common/Loader";
import { getUserProfileDetails } from "../../../redux/features/getUserProfile";
import { getAllCountrie } from "../../../services/authServices";
import { updateUserProfileDetails } from "../../../services/services";

let errInputStyle = {
  color: "red",
  fontSize: "0.7rem",
  marginLeft: "0.5rem",
  // marginTop: "-1rem",
  background: "#fff",
  width: "max-content",
  padding: "2px 4px",
};

export default function EditProfile() {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    setError,
    reset,
    formState: { errors, defaultValues },
  } = useForm({
    first_name: "",
    last_name: "",
    mobile_no: "",
    country_code: "",
    date_of_birth: "",
  });
  const [isLoader, setIsLoader] = useState(true);
  const [isCountryCodes, setIsCountryCodes] = useState(false);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [allCountries, setAllCountries] = useState([]);
  const [mobileNumber, setMobileNumber] = useState();
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const countryData = useSelector((state) => state.getCountries.result);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const date_of_birth = watch("date_of_birth", false);

  const userId = localStorage.getItem("userId");
  const session_id = localStorage.getItem("session_id");
  // const userDetails = JSON.parse(localStorage.getItem("userInfo"));
  const userDetails = useSelector((state) => state.userProfile?.result?.data);

  const onSubmit = (data, e) => {
    // updateUserProfile(data);
    callUpdateUserProfile(userId, data);
  };

  const handleClose = () => {
    setIsCountryCodes(false);
  };

  const handleCalendarDate = (date) => {
    let dt = moment(date).format("DD-MM-YYYY");
    setValue("date_of_birth", dt);
    setOpenDateModal(false);
  };

  const callUpdateUserProfile = async (user_id, data) => {
    try {
      const request = await updateUserProfileDetails(user_id, data);
      const response = await request.data;

      if (response.status == 1) {
        if (response.status == 1) {
          setOpenSuccessModal(true);
          setTimeout(() => {
            navigate(-1);
            dispatch(getUserProfileDetails(user_id));
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCountryState = ({
    country_code,
    country_name,
    flag: flag_image,
  }) => {
    setValue("country_code", country_code);
    setMobileNumber({
      country_code,
      country_name,
      flag: flag_image,
    });
  };

  useEffect(() => {
    if (!userDetails?.country_code || !allCountries?.length) return;

    // Normalise: remove leading "+" if present
    const cleanCode = userDetails.country_code.replace(/^\+/, "");

    const filterFlag = allCountries.find(
      (i) => String(i.callingCodes) === String(cleanCode)
    );

    if (filterFlag) {
      setMobileNumber({
        country_code: filterFlag.callingCodes,
        flag: filterFlag?.flag,
        country_name: filterFlag.name,
      });
    }
  }, [allCountries, userDetails]);

  // const callGetUserAPI = async () => {
  //   try {
  //     const request = await getUserById(userId);
  //     const response = await request.data;

  //     if (response.status == 1) {
  //       setValue("first_name", response.data?.first_name);
  //       setValue("last_name", response.data?.last_name);
  //       setError("first_name", true);
  //       setValue("mobile_no", response?.data?.mobile_no);
  //       setValue("date_of_birth", response?.data?.date_of_birth);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setIsLoader(false);
  //   }
  // };

  useEffect(() => {
    setValue("first_name", userDetails?.first_name);
    setError("first_name", true);
    setValue("last_name", userDetails?.last_name);
    setValue("email", userDetails?.email);
    setValue("mobile_no", userDetails?.mobile_no);
    setValue("date_of_birth", userDetails?.date_of_birth);
    setValue(
      "country_code",
      userDetails?.country_code?.replace(/^\+/, "") || ""
    );
    setMobileNumber({});

    setIsLoader(false);
  }, [setValue, userDetails, setError]);

  const ageLimit = () => {
    let dt = new Date();
    if (dt) {
      dt.setFullYear(dt.getFullYear() - 18);
    }
    return dt;
  };

  // const callAllCountries = async () => {
  //   try {
  //     const request = await getAllCountrie();
  //     const response = await request.data;

  //     if (response.status == 1) {
  //       setAllCountries(response?.data?.data);
  //       let defaultCountry = response?.data?.data.find(
  //         (x) => x.name === "Singapore"
  //       );
  //       setMobileNumber({
  //         country_code: defaultCountry?.callingCodes,
  //         country_name: defaultCountry?.name,
  //         flag: defaultCountry?.flag,
  //       });
  //     }
  //   } catch (error) {}
  // };

  useEffect(() => {
    // callGetUserAPI();
    // callAllCountries();
  }, []);

  useEffect(() => {
    setAllCountries(countryData?.data);
    let defaultCountry = countryData?.data?.find((x) => x.name === "Singapore");
    setMobileNumber({
      country_code: defaultCountry?.callingCodes,
      country_name: defaultCountry?.name,
      flag: defaultCountry?.flag,
    });
  }, [countryData]);

  return (
    <Box>
      {isLoader && <LoadingSpinner />}
      <Header header="Edit Profile" />
      <Drawer open={isCountryCodes} anchor="bottom">
        <CountryModal
          defaultSelected={mobileNumber?.country_name}
          close={setIsCountryCodes}
          data={allCountries}
          setState={getCountryState}
        />
      </Drawer>

      <Drawer
        open={openDateModal}
        anchor="top"
        onClose={() => setOpenDateModal(false)}
      >
        <Calendar
          date={
            date_of_birth ? new Date(ReadableDate(date_of_birth)) : new Date()
          }
          onChange={handleCalendarDate}
          className="calendar_picker"
          color="var(--brandColor)"
          rangeColors={[
            "var(--brandColor)",
            "var(--brandColor)",
            "var(--brandColor)",
          ]}
          maxDate={ageLimit()}
        />
      </Drawer>

      <Box sx={{ padding: "1rem", height: "91svh", position: "relative" }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0rem",
            }}
          >
            <div className={style.mainBoxContainer}>
              <Box className={style.boxContainer}>
                <p>
                  First Name <span className={style.important_lable}>*</span>
                </p>
                <input
                  type="text"
                  {...register("first_name", {
                    required: "First name is required!",
                    minLength: {
                      value: 2,
                      message: "First name should be atleast 2 characters",
                    },
                    pattern: {
                      value: /^[A-Za-z]+$/i,
                      message: "First name should contain only letters",
                    },
                  })}
                />
              </Box>
              {errors.first_name && (
                <p style={{ ...errInputStyle }}>{errors.first_name?.message}</p>
              )}
            </div>
            <div className={style.mainBoxContainer}>
              <Box className={style.boxContainer}>
                <p>
                  Last Name <span className={style.important_lable}>*</span>
                </p>
                <input
                  type="text"
                  {...register("last_name", {
                    required: "Last name is required!",
                    minLength: {
                      value: 2,
                      message: "Last name should be atleast 2 characters",
                    },
                    pattern: {
                      value: /^[A-Za-z]+$/i,
                      message: "Last name should contain only letters",
                    },
                  })}
                />
              </Box>
              {errors.last_name && (
                <p style={{ ...errInputStyle }}>{errors.last_name?.message}</p>
              )}
            </div>
            <div className={style.mainBoxContainer}>
              <Box className={style.boxContainer}>
                <p>
                  Mobile Number <span className={style.important_lable}>*</span>
                </p>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                    }}
                  >
                    <img src={mobileNumber?.flag} className="flag" alt="flag" />

                    <div
                      className={style.mobile_code_field_container}
                      onClick={() => setIsCountryCodes(true)}
                    >
                      <span className={style.mobile_code_field}>
                        + {mobileNumber?.country_code}
                      </span>
                      <img
                        src={dropdown}
                        style={{ width: "1rem" }}
                        alt="arrow_icon"
                      />
                    </div>

                    <div className={style.input_container}>
                      <input
                        type="tel"
                        {...register("mobile_no", {
                          required: "Mobile number is required",
                          minLength: {
                            value: 2,
                            message: "At least 2 digits are required",
                          },
                          maxLength: {
                            value: 12,
                            message: "Mobile number cannot exceed 12 digits",
                          },
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Only numbers are allowed",
                          },
                        })}
                        autoComplete="off"
                      />
                    </div>
                  </Box>
                </Box>
              </Box>
              {errors.mobile_no && (
                <p style={{ ...errInputStyle }}>{errors.mobile_no?.message}</p>
              )}
            </div>
            <div className={style.mainBoxContainer}>
              <Box className={`${style.boxContainer} ${style.emailContainer}`}>
                <p>
                  Email <span className={style.important_lable}>*</span>
                </p>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Box
                    style={{
                      width: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => setIsCountryCodes(true)}
                  >
                    <AiOutlineMail />
                  </Box>

                  <input
                    type="email"
                    disabled
                    {...register("email", {
                      required: "Email Address is required!",
                      validate: {
                        matchPattern: (v) =>
                          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                            v
                          ) || "Please Enter Valid Email address",
                      },
                    })}
                    autoComplete="off"
                  />
                </Box>
              </Box>
              {errors.email && (
                <p style={{ ...errInputStyle }}>{errors.email?.message}</p>
              )}
            </div>
            <div className={style.mainBoxContainer}>
              <Box
                className={style.boxContainer}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                onClick={() => setOpenDateModal(true)}
              >
                <Box>
                  <p>
                    Date of Birth{" "}
                    {/* <span className={style.important_lable}>*</span> */}
                  </p>
                  <input
                    readOnly
                    placeholder="DD-MM-YYYY"
                    {...register("date_of_birth", { required: "" })}
                  />
                </Box>
                <Box>
                  <SlCalender style={{ fontSize: "1.4rem" }} />
                </Box>
              </Box>
            </div>
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: "5%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              type="submit"
              onClick={() => {
                handleSubmit(onSubmit);
              }}
              className={style.save_button}
              style={{ backgroundColor: "#8647AF" }}
            >
              Save
            </Button>
          </Box>
        </form>
      </Box>
      <Dialog
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
      >
        <DialogTitle className={style.success_modal_title}>
          Changes are Saved!
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center" }}>
          <img
            style={{ height: 147, width: 147 }}
            src={checkAnimation}
            alt="success icon"
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

function ReadableDate(value) {
  const splitArray = value?.split("-");
  const date = splitArray[0];
  const month = splitArray[1];
  const year = splitArray[2];
  return month + "/" + date + "/" + year;
}
